export default "__VITE_ASSET__frargHIC__"